/**
 * Singleton TokenManager instance
 * Shared across all API calls in the application
 * 
 * Initialize once at app startup, use everywhere
 */


import {
 TokenManager, TokenManagerConfig
} from './tokenManager';

let tokenManagerConfig: TokenManagerConfig | null = null;


export const TokenManagerInstance = {
  initializeTokenManager(config: TokenManagerConfig) {
    tokenManagerConfig = config;
    console.log('TokenManager initialized (functional)');
  },


  getTokenManagerConfig(): TokenManagerConfig {
    if (!tokenManagerConfig) {
      throw new Error('TokenManager not initialized. Call initializeTokenManager() first.');
    }
    return tokenManagerConfig;
  },

  isTokenManagerInitialized(): boolean {
    return tokenManagerConfig !== null;
  },

  resetTokenManager(): void {
    tokenManagerConfig = null;
  },

// // Proxy functions for token operations using the stored config
//   async getValidTokenInstance(): Promise<string | null> {
//     return TokenManager.getValidToken(TokenManagerInstance.getTokenManagerConfig());
//   },

//   async refreshTokenInstance(): Promise<string> {
//     return TokenManager.refreshToken(TokenManagerInstance.getTokenManagerConfig());
//   },

  
};
